/*
 * "Message" : {
 *   "required" : ["id", "messageText"],
 *   "type" : "object",
 *   "properties" : {
 *     "id" : {
 *       "description" : "Nachricht-ID",
 *       "type" : "string"
 *     },
 *     "messageText" : {
 *       "description" : "Text der Nachricht (entweder generisch oder individuell)",
 *       "type" : "string"
 *     }
 *   }
 * },
 */

export enum MessageKind {
  info,
  warning,
  success,

  notification,
}

export class Message {
  constructor(
    public id: string,
    public text: string,
    public kind: MessageKind,
  ) { }

  public static fromJSON(json: {
    id: string,
    messageText: string,
  }): Message {
    if (!json) {
      throw new Error('Message JSON should not be undefined');
    }
    if (!json.id) {
      throw new Error('Message JSON should have property: id');
    }
    if (!json.messageText) {
      throw new Error('Message JSON should have property: messageText');
    }

    return new Message(
      json.id,
      json.messageText.replace(/^\s*/gi, ''),
      MessageKind.notification,
    );
  }

  // ===== Convenience initializer ===== //

  public static info(text: string): Message {
    return new Message(
      `internal${Date.now()}`,
      text,
      MessageKind.info,
    );
  }

  public static warning(text: string): Message {
    return new Message(
      `internal${Date.now()}`,
      text,
      MessageKind.warning,
    );
  }

  public static success(text: string): Message {
    return new Message(
      `internal${Date.now()}`,
      text,
      MessageKind.success,
    );
  }

  // ===== Public helper/convenience getters ===== //

  public get isNotification(): boolean {
    return this.kind === MessageKind.notification;
  }

  public get isInfo(): boolean {
    return this.kind === MessageKind.info;
  }

  public get isWarning(): boolean {
    return this.kind === MessageKind.warning;
  }

  public get isSuccess(): boolean {
    return this.kind === MessageKind.success;
  }
}
